export default {
    path: '/device',
    component: () => import('@/views/layout.vue'),
    redirect: '/deviceList',
    name: 'device',
    sort: 8,
    icon: 'el-icon-mobile',
    meta: { title: '设备管理', authCode: ['S001'] },
    children: [
        {
            path: '/deviceList',
            name: 'deviceList',
            component: () => import('@/views/permission/device/deviceList.vue'),
            meta: {
                keepAlive: true,
                title: '设备台账',
                authCode: ['S0001']
            }
        },
        {
            path: '/dailyCheckOrder',
            name: 'dailyCheckOrder',
            component: () => import('@/views/permission/device/dailyCheckOrder.vue'),
            meta: {
                keepAlive: true,
                title: '日常点检',
                authCode: ['S0002']
            }
        },
        {
            path: '/planMantainOrder',
            name: 'planMantainOrder',
            component: () => import('@/views/permission/device/planMantainOrder.vue'),
            meta: {
                keepAlive: true,
                title: '计划保养',
                authCode: ['D0001']
            }
        },
        {
            path: '/faultCode',
            name: 'faultCode',
            component: () => import('@/views/permission/device/faultCode.vue'),
            meta: {
                title: '故障代码',
                authCode: ['FAULTCODE001']
            }
        },
        {
            path: '/abilityDetectnOrderList',
            name: 'AbilityDetectnOrderList',
            component: () => import('@/views/permission/ability/abilityDetectnOrderList.vue'),
            meta: {
                title: '能力检测',
                 authCode: ['NL0004']
            }
        },
        {
            path: '/historicalExp',
            name: 'historicalExp',
            component: () => import('@/views/permission/device/historicalExp.vue'),
            meta: {
                title: '历史经验',
                authCode: ['HISEXP001']
            }
        },
        {
            path: '/abilityDetectnOrderInfo',
            name: 'AbilityDetectnOrderInfo',
            component: () => import('@/views/permission/ability/abilityDetectnOrderInfo.vue'),
            hidden: true,
            meta: {
                title: '能力检测工单详情',
            }
        },
        {
            path: '/addPlanMantainOrder',
            name: 'addPlanMantainOrder',
            hidden: true,
            component: () => import('@/views/permission/device/addPlanMantainOrder.vue'),
            meta: {
                title: '新增计划工单',
            }
        },
        {
            path: '/editPlanMantainOrder',
            name: 'editPlanMantainOrder',
            hidden: true,
            component: () => import('@/views/permission/device/editPlanMantainOrder.vue'),
            meta: {
                title: '编辑计划工单',
            }
        },
        {
            path: '/dailyCheckDetail',
            name: 'dailyCheckDetail',
            hidden: true,
            component: () => import('@/views/permission/device/dailyCheckDetail.vue'),
            meta: {
                title: '设备点检详情',
            }
        },
        {
            path: '/addDevice',
            name: 'addDevice',
            hidden: true,
            component: () => import('@/views/permission/device/addDevice.vue'),
            meta: {
                title: '设备新增',
            }
        },
        {
            path: '/editDevice',
            name: 'editDevice',
            hidden: true,
            component: () => import('@/views/permission/device/editDevice.vue'),
            meta: {
                title: '设备编辑',
            }
        }
    ]
}
